import shortid from "shortid";


export const BRANDKIT_COLOR_COMPONENT = () => {
    return {
      id: shortid(),
      name: "Untitled",
      entityType: "palette_component",
      newComponent: true,
      order: 1,
      draft: {
        widgets: [],
        type: "color",
        content: [
          {
            a: "1",
            b: "44",
            g: "33",
            r: "33",
            type: "solid",
          },
        ],
        fonts: null,
      },
    };
  };